/* GG cart integrity + mobile add-to-cart.

   THREE PARTS.

   1. CART-PAGE REPAIR + RECONCILER — runs on every viewport (desktop AND mobile).
      a) DEVICE REPAIR: if the customer's last add-to-cart tap is still pending and
         its device is not in the cart, put it there. See the note above
         repairPendingDevice for how a device could go missing at all.
      b) WARRANTY RECONCILE: every device line that records a chosen warranty must
         have a warranty line paired to it, in the SAME QUANTITY, and any warranty
         line that no device claims is removed. Neither is guaranteed by the theme:
         the cart page has no quantity sync of its own (cart-logic.js has one but is
         not loaded there).

   2. NATIVE-NAVIGATION GUARD — mobile only.
      Cancels ONLY the browser's native form POST, so the page is not unloaded.
      Every other submit listener still runs. This is what makes part 3 possible.

   3. MOBILE ADD-TO-CART ORCHESTRATOR — mobile only.
      On phones this file is the sole orchestrator; the theme's synchronous one is
      disabled in snippets/warranty-card-styles.liquid because it froze the page.
      Flow: overlay -> let apps add -> wait for the cart to stop changing -> re-add
      the device if it was dropped (adopting/minting an _io group so the warranty
      stays linked) -> add the warranty if this device is not covered -> go to /cart.
      Everything is checked before adding, so nothing can duplicate; repeat taps are
      ignored. */
(function () {
  var d = document, busy = false;
  var PENDKEY = '__gg_pending_device';

  // Diagnostics: OFF for customers. Append ?ggdebug=1 to any URL to turn it on for
  // that browsing session; a readout then appears on the cart page.
  var DEBUG = false, LOGKEY = '__gg_atc_log';
  try {
    if (/[?&]ggdebug=1/.test(location.search)) sessionStorage.setItem('__gg_debug', '1');
    DEBUG = sessionStorage.getItem('__gg_debug') === '1';
  } catch (_) {}
  function log(tag, data) {
    if (!DEBUG) return;
    try {
      var a = JSON.parse(sessionStorage.getItem(LOGKEY) || '[]');
      var e = { tag: tag, t: Date.now() };   // timestamp, debug sessions only
      for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) e[k] = data[k]; }
      a.push(e);
      sessionStorage.setItem(LOGKEY, JSON.stringify(a.slice(-40)));
    } catch (_) {}
  }

  function clearPending() { try { sessionStorage.removeItem(PENDKEY); } catch (_) {} }

  // PART 1 — all viewports. Repair a missing device first, then reconcile warranties.
  if (location.pathname.indexOf('/cart') === 0) {
    // REMOVING A WARRANTY. The Remove link on a warranty line only removed that line;
    // the device kept "Green Gadgets Warranty: 24 Months ($X)" and its _io group, so
    // the cart said "warranty chosen, none present". Tested 30/09 (3/3, desktop and
    // mobile): the device was then removed as well and the cart ended EMPTY, and the
    // reconciler below would otherwise have put the warranty straight back. Now the
    // warranty line goes AND the device's warranty choice is cleared, so the phone
    // stays as a normal no-warranty line. Runs in capture, before the theme's handler.
    d.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('.line-item__quantity-remove, a[href*="/cart/change"][href*="quantity=0"]');
      if (!a) return;
      var row = a.closest('.line-item') || a.closest('tr');   // not [data-line]: the link itself carries it
      if (!row || !/Extended Warranty/i.test(row.textContent || '')) return;
      var m = (a.getAttribute('href') || '').match(/[?&]line=(\d+)/);
      var lineNo = m ? parseInt(m[1], 10) : parseInt(a.getAttribute('data-line') || '0', 10);
      if (!lineNo) return;
      e.preventDefault(); e.stopImmediatePropagation();
      removeWarrantyLine(lineNo);
    }, true);

    repairPendingDevice(function (repaired) {
      if (repaired) { location.reload(); return; }   // re-run on a clean cart
      reconcileCart();
    });
  }

  // ---- PART 2 + 3: everything below here is mobile-only. Desktop keeps the theme's
  // ---- own add-to-cart flow untouched.
  if (!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches)) return;

  // NATIVE-NAVIGATION GUARD.
  // A product form without an AJAX handler performs a real POST to /cart/add, which
  // UNLOADS the page. That killed every recovery step below — the 700ms timer, the
  // settle poll, ensureDevice, ensureWarranty — because the JS context died with the
  // page. Meanwhile Infinite Options and Essential Upsell add their own lines over
  // AJAX and can redirect to /cart on their own, so the observable result was a cart
  // holding a warranty and accessories with NO DEVICE.
  //
  // preventDefault cancels the native navigation ONLY. It does not stop propagation,
  // so the app listeners on this same submit event still fire and still add their
  // lines. The device itself is then guaranteed by ensureDevice below, which checks
  // the cart before adding and so cannot duplicate it.
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('product-form')) return;
    var submitter = e.submitter;
    if (submitter && submitter.name && submitter.name !== 'add') return;
    e.preventDefault();
    log('navGuard', { blocked: 'native-post' });
  }, true);

  // In-flight /cart/add requests from ANY code on the page (Essential Upsell adds the
  // accessories itself). The fast path below waits for these to finish instead of
  // polling the cart for "no change in 1.2 s", which is what made mobile slow.
  var addsPending = 0, lastAddDone = 0;
  (function () {
    var of = window.fetch;
    if (!of || of.__ggTracked) return;
    var wrapped = function (input) {
      var url = String(input && input.url ? input.url : input);
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      if (isAdd) addsPending++;
      var p = of.apply(this, arguments);
      if (isAdd) p.then(done, done);
      return p;
    };
    function done() { addsPending = Math.max(0, addsPending - 1); lastAddDone = Date.now(); }
    wrapped.__ggTracked = true;
    window.fetch = wrapped;
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__ggAdd = /\/cart\/add(\.js)?(\?|$)/.test(String(u)); return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__ggAdd) { addsPending++; this.addEventListener('loadend', done); }
      return os.apply(this, arguments);
    };
  })();

  // Warranties already in the cart at page load. Used only as a fallback when a
  // device carries no _io group to match a warranty against.
  var warrantyBefore = 0;
  var warrantyBeforeReady = cartJson().then(function (c) { warrantyBefore = countWarranties(c); }, function () {});

  // The cart as it was when this page was shown. The mobile flow must judge what THIS tap added, not what
  // the cart already held: 01/10/2026 Rod added iPhone + warranty, came back and added the same iPhone
  // alone — it was ignored, because "is this variant in the cart?" was already true.
  var baseline = null;
  var baselineReady = cartJson().then(function (c) { baseline = c; }, function () { baseline = { items: [] }; });
  // Back button (bfcache) restores this page with its old JS state: busy stuck at true (every tap ignored)
  // and a stale baseline. Reset both when that happens.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    busy = false;
    var o = d.getElementById('gg-atc-overlay'); if (o && o.parentNode) o.parentNode.removeChild(o);
    baselineReady = cartJson().then(function (c) { baseline = c; warrantyBefore = countWarranties(c); }, function () {});
  });

  d.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-form__add-button');
    if (!btn) return;
    var form = btn.form || (btn.closest && btn.closest('form.product-form'));
    if (!form) return;
    if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; } // ignore repeat taps
    var idEl = form.querySelector('[name="id"]');
    var qEl = form.querySelector('[name="quantity"]');
    var variantId = idEl ? String(idEl.value) : null;
    var qty = (qEl && parseInt(qEl.value, 10) > 0) ? parseInt(qEl.value, 10) : 1;
    if (!variantId) return;
    var warrantyPrice = readWarrantyPrice();   // captured at click time
    var warrantyLabel = (d.querySelector('input[name="properties[Green Gadgets Warranty]"]') || {}).value || '';
    busy = true;
    showOverlay();
    // Record the intent NOW, before anything can navigate. sessionStorage survives a
    // page unload; the timers below do not. If this tap somehow still ends with the
    // device missing, the cart page repairs it from this record.
    try {
      sessionStorage.setItem(PENDKEY, JSON.stringify({ v: variantId, q: qty, w: warrantyLabel, t: Date.now() }));
    } catch (_) {}
    log('click', { variant: variantId, priceRead: warrantyPrice, wBefore: warrantyBefore });
    // NOTE: the baseline is deliberately the PAGE-LOAD count (measured above).
    // Re-measuring at click time would race the warranty app: if its add lands
    // first, this tap's own warranty would be counted as "already there" and
    // skipped — which is exactly the failure we are fixing.
    // 01/10/2026: back to check-then-add. The blind one-request fast path (V1.02.1) DOUBLED the cart on real
    // phones: there Infinite Options adds the warranty and the theme adds the device on their own, and the fast
    // path added device + warranty again (reproduced with Android + touch emulation: 2 devices, 2 warranties).
    // settle() waits for the page's adds to finish, then ensureDevice/ensureWarranty add only what is missing.
    // Timings tightened instead (see settle).
    setTimeout(function () { settle(variantId, qty, warrantyPrice); }, 300);
  }, true);

  // Warranty product variant for a price tier, e.g. 49 -> the "$49 Extended Warranty".
  var warrantyVidCache = {};
  function warrantyVariantId(price) {
    if (!price) return Promise.resolve(null);
    if (warrantyVidCache[price]) return Promise.resolve(warrantyVidCache[price]);
    return fetch('/products/' + price + '-green-gadgets-extended-warranty-24-months.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var vid = p && p.variants && p.variants[0] && p.variants[0].id;
        if (vid) warrantyVidCache[price] = vid;
        return vid || null;
      }, function () { return null; });
  }
  // Prefetch the tier as soon as the customer switches the warranty on, so the tap does
  // not wait for it.
  d.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#infiniteoptions-container')) {
      setTimeout(function () { warrantyVariantId(readWarrantyPrice()); }, 50);
    }
  }, true);

  function readWarrantyPrice() {
    var cont = d.getElementById('infiniteoptions-container');
    var chk = d.querySelector('#infiniteoptions-container input[type="checkbox"]');
    var selected = (chk && chk.checked) || (cont && cont.classList.contains('wc-active'));
    if (!selected) return null;
    var sources = [];
    if (chk) sources.push(chk.value);
    var hp = d.querySelector('input[name="properties[Green Gadgets Warranty]"]');
    if (hp) sources.push(hp.value);
    if (cont) { var pe = cont.querySelector('.wc-price'); if (pe) sources.push(pe.textContent); }
    for (var i = 0; i < sources.length; i++) {
      var m = String(sources[i] || '').match(/\$\s*([\d.,]+)/);
      if (m) return m[1].replace(/,/g, '').replace(/\.0+$/, '');
    }
    return null;
  }

  function settle(variantId, qty, warrantyPrice) {
    var start = Date.now(), lastCount = -1, stableSince = Date.now();
    (function poll() {
      cartJson().then(function (cart) {
        if (cart.item_count !== lastCount) { lastCount = cart.item_count; stableSince = Date.now(); }
        // Settled = no /cart/add in flight (tracked from page load), cart unchanged for 600 ms, and at least
        // 1 s since the tap so an app that starts its add a moment later is not missed. (Was: unchanged
        // 1.2 s, polled every 400 ms, no in-flight check.)
        var settled = addsPending === 0 && (Date.now() - stableSince) > 600 && (Date.now() - start) > 1000;
        var timedOut = (Date.now() - start) > 9000;
        if (settled || timedOut) { log('settle', { ms: Date.now() - start, items: cart.item_count }); baselineReady.then(function () { ensureDevice(cart, variantId, qty, warrantyPrice); }); }
        else setTimeout(poll, 250);
      }, function () { setTimeout(poll, 500); });
    })();
  }

  function variantLines(c, v) {
    return ((c && c.items) || []).filter(function (i) { return String(i.variant_id) === v; });
  }

  function ensureDevice(cart, variantId, qty, warrantyPrice) {
    // How many units of this variant did THIS tap add (vs the page-load baseline), and which line is new.
    var before = {};
    variantLines(baseline, variantId).forEach(function (i) { before[i.key] = i.quantity; });
    var added = 0, existing = null;
    variantLines(cart, variantId).forEach(function (i) {
      var grew = i.quantity - (before[i.key] || 0);
      if (grew > 0) { added += grew; if (!existing || !before[i.key]) existing = i; }
    });
    var isNewLine = existing && !before[existing.key];
    if (existing && added >= qty) {
      var g = existing.properties && existing.properties._io_order_group;
      // The device line carries the customer's choice as a visible property
      // ("Green Gadgets Warranty: 24 Months ($59)"). That is authoritative — it is
      // what the form actually submitted — so fall back to it when the click-time
      // DOM read came back empty, which happens if the warranty widget re-rendered
      // between the tap and the read. Without this the warranty is silently never
      // added: the cart shows the selection but nothing is charged for it.
      // Only trust the line's recorded warranty when the line is new (added by this tap); an older line's
      // choice says nothing about what the customer picked now.
      var wp = warrantyPrice || (isNewLine ? priceFromProps(existing.properties) : null);
      log('device', { present: true, added: added, group: g || null, priceUsed: wp });
      ensureWarranty(qty, wp, g || null);
      return;
    }
    // Device was dropped — re-add it. Adopt the orphaned warranty's group when there is
    // one; otherwise mint a fresh group id, so that a warranty we add ourselves can still
    // be linked to this device. An unlinked warranty stays in the cart but is no longer
    // removed together with its device, which is what we must avoid.
    var orphan = findOrphanGroup(cart);                // a warranty the app added without its device
    var group = orphan || String(Date.now());
    var props = { _io_order_group: group };
    // Carry over the customer-visible warranty choice exactly as the form submits
    // it. Without this the re-added device no longer says it wants a warranty, so
    // the cart reconciler above can't tell it needs one — and a warranty lost later
    // would never be restored. We're still on the product page here, so the form's
    // hidden input is the authoritative source.
    var lbl = (d.querySelector('input[name="properties[Green Gadgets Warranty]"]') || {}).value;
    if (lbl) props['Green Gadgets Warranty'] = lbl;
    var need = Math.max(1, qty - added);                // only the shortfall of THIS tap
    var body = { id: parseInt(variantId, 10), quantity: need, properties: props };
    log('device', { present: false, readding: variantId, need: need, group: group });
    // 01/10/2026: when the warranty is missing too (no orphan to adopt), send device + warranty in ONE
    // request instead of two in a row. ensureWarranty still checks the cart afterwards and adds only if
    // the warranty is really not there, so nothing can double.
    warrantyVariantId(orphan ? null : warrantyPrice).then(function (wVid) {
      var items = [body];
      if (wVid) items.push({ id: wVid, quantity: need, properties: { '_io_field_name': 'Green Gadgets Warranty', '_io_parent_order_group': group } });
      return addJson({ items: items });
    }).then(
      function () { ensureWarranty(need, warrantyPrice, group); },
      function () { ensureWarranty(need, warrantyPrice, group); }
    );
  }

  // Warranty price as recorded on a cart line by the form, e.g. "24 Months ($59)".
  function priceFromProps(props) {
    if (!props) return null;
    var v = props['Green Gadgets Warranty'];
    if (!v) return null;
    var m = String(v).match(/\$\s*([\d.,]+)/);
    return m ? m[1].replace(/,/g, '').replace(/\.0+$/, '') : null;
  }

  function findOrphanGroup(cart) {
    var parents = {};
    (cart.items || []).forEach(function (i) {
      var g = i.properties && i.properties._io_order_group;
      if (g !== undefined && g !== null) parents[g] = true;
    });
    var orphan = null;
    (cart.items || []).forEach(function (i) {
      var pg = i.properties && i.properties._io_parent_order_group;
      if (pg !== undefined && pg !== null && !parents[pg]) orphan = pg;
    });
    return orphan;
  }

  // Is THIS device already covered? Judged per device via the Infinite Options
  // link (warranty._io_parent_order_group === device._io_order_group), never by a
  // global warranty count: with several devices in one cart, a rising total says
  // nothing about whether *this* device got its warranty. That global count is
  // what let a 2nd device silently end up uncovered.
  function hasWarrantyFor(cart, group) {
    if (!group) return null;                   // no link available — cannot tell
    return (cart.items || []).some(function (i) {
      return i.properties && String(i.properties._io_parent_order_group) === String(group) &&
             (/Extended Warranty/i.test(i.title || '') || i.properties._io_field_name);
    });
  }

  function ensureWarranty(qty, warrantyPrice, group) {
    if (!warrantyPrice) { log('warranty', { decision: 'no-price' }); go(); return; }
    cartJson().then(function (cart) {
      var covered = hasWarrantyFor(cart, group);
      log('warranty', { covered: covered, price: warrantyPrice, group: group || null, total: countWarranties(cart), before: warrantyBefore });
      // Fall back to the count heuristic only when the device carries no group at
      // all, so there is nothing to match a warranty against.
      if (covered === null) covered = countWarranties(cart) > warrantyBefore;
      if (!covered) { addWarranty(qty, warrantyPrice, group); return; }
      // Covered — but the app can still roll its own line back a moment later.
      // Re-check once before leaving; a selected warranty must never be missing
      // when the customer reaches the cart.
      setTimeout(function () {
        cartJson().then(function (c2) {
          var still = hasWarrantyFor(c2, group);
          if (still === null) still = countWarranties(c2) > warrantyBefore;
          if (still) go(); else addWarranty(qty, warrantyPrice, group);
        }, go);
      }, 900);
    }, go);
  }

  function addWarranty(qty, warrantyPrice, group) {
    warrantyVariantId(warrantyPrice)
      .then(function (vid) {
        if (!vid) { log('addWarranty', { error: 'no-variant' }); go(); return; }
        var props = { '_io_field_name': 'Green Gadgets Warranty' };
        // Link the warranty to its device so the cart page removes them together.
        if (group) props['_io_parent_order_group'] = group;
        addJson({ id: vid, quantity: qty, properties: props }).then(
          function (r) { log('addWarranty', { variant: vid, status: r && r.status }); go(); },
          function () { log('addWarranty', { status: 'network-error' }); go(); }
        );
      }, function () { log('addWarranty', { error: 'fetch-failed', price: warrantyPrice }); go(); });
  }

  function countWarranties(cart) {
    return (cart.items || []).filter(function (i) {
      return /Extended Warranty/i.test(i.title || '') || (i.properties && i.properties._io_field_name);
    }).reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
  }
  function cartJson() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function addJson(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function go() { log('go', {}); clearPending(); window.location.href = '/cart'; }

  // Debug readout on the cart page (only when ?ggdebug=1 armed the session).
  if (DEBUG && location.pathname.indexOf('/cart') === 0) {
    try {
      var entries = JSON.parse(sessionStorage.getItem(LOGKEY) || '[]');
      if (entries.length) {
        var box = d.createElement('details');
        box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99998;background:#fff;border:1px solid #cfe0bf;border-radius:8px;padding:8px 10px;font:11px/1.35 monospace;color:#2f3a2a;box-shadow:0 2px 10px rgba(0,0,0,.15);max-height:45vh;overflow:auto';
        var sum = d.createElement('summary');
        sum.style.cssText = 'cursor:pointer;font-weight:700';
        sum.textContent = 'ATC diagnostic (' + entries.length + ') — tap to open';
        box.appendChild(sum);
        var pre = d.createElement('pre');
        pre.style.cssText = 'margin:6px 0 0;white-space:pre-wrap;word-break:break-all';
        pre.textContent = entries.map(function (e) {
          var parts = [];
          for (var k in e) { if (k !== 'tag' && Object.prototype.hasOwnProperty.call(e, k)) parts.push(k + '=' + e[k]); }
          return e.tag + ': ' + parts.join(' ');
        }).join('\n');
        box.appendChild(pre);
        if (d.body) d.body.appendChild(box);
        else d.addEventListener('DOMContentLoaded', function () { d.body.appendChild(box); });
      }
    } catch (_) {}
  }

  // --- DEVICE REPAIR (cart page, all viewports) -----------------------------
  // Why a device can be missing at all: the product form's native POST unloads the
  // page, which kills the orchestrator above mid-flight, while Infinite Options and
  // Essential Upsell add their lines over AJAX and can redirect to /cart themselves.
  // The customer then lands on a cart holding a warranty and accessories but no
  // phone. Part 2 now prevents that unload, and this is the belt-and-braces: the tap
  // recorded what it wanted before anything could navigate, so if the device still
  // is not here, put it there.
  //
  // The record is honoured for two minutes only. After that the customer has had
  // time to change their mind, and re-adding a device they deliberately removed
  // would be worse than the bug being fixed. It is also cleared as soon as it is
  // used, or once the device is confirmed present, so it can never fire twice.
  function repairPendingDevice(done) {
    var pend = null;
    try { pend = JSON.parse(sessionStorage.getItem(PENDKEY) || 'null'); } catch (_) {}
    if (!pend || !pend.v) { done(false); return; }
    if (Date.now() - (pend.t || 0) > 120000) { clearPending(); done(false); return; }
    cartJson().then(function (cart) {
      var present = (cart.items || []).some(function (i) { return String(i.variant_id) === String(pend.v); });
      if (present) { clearPending(); log('repair', { decision: 'device-present' }); done(false); return; }
      var group = findOrphanGroup(cart) || String(Date.now());
      var props = { _io_order_group: group };
      if (pend.w) props['Green Gadgets Warranty'] = pend.w;
      log('repair', { readding: pend.v, qty: pend.q || 1, group: group });
      addJson({ id: parseInt(pend.v, 10), quantity: pend.q || 1, properties: props }).then(
        function () { clearPending(); done(true); },
        function () { clearPending(); done(false); }
      );
    }, function () { done(false); });
  }

  // --- Cart-page reconciler -------------------------------------------------
  // Last line of defence, and the important one: when the warranty app does not
  // intercept the form, the browser performs a native POST and LEAVES the product
  // page, so none of the recovery above ever runs. The device still lands in the
  // cart carrying "Green Gadgets Warranty: 24 Months ($X)" while nothing is
  // charged for it. Here we re-check on the cart page itself: every device line
  // that records a chosen warranty must have a warranty line paired to it.
  function isWarrantyLine(i) {
    return /Extended Warranty/i.test(i.title || '') || !!(i.properties && i.properties._io_field_name);
  }

  // The 15 s guard stops a reconcile -> reload -> reconcile loop. It used to simply
  // give up, so a second quantity change inside those 15 s was never reconciled
  // until some later cart load (30/09: iPhone x2 with ONE warranty, still like that
  // 25 s later, one tap from checkout). Now it retries once the guard has expired,
  // capped at 4 reconciles in 2 minutes so a state that never converges cannot loop.
  var reconRetry = null;
  function reconcileCart() {
    var last = 0;
    try { last = parseInt(sessionStorage.getItem('__gg_recon') || '0', 10); } catch (_) {}
    var wait = 15000 - (Date.now() - last);
    if (wait > 0) {
      if (!reconRetry) reconRetry = setTimeout(function () { reconRetry = null; reconcileCart(); }, wait + 300);
      return;
    }
    var runs = [];
    try { runs = JSON.parse(sessionStorage.getItem('__gg_recon_runs') || '[]'); } catch (_) {}
    runs = runs.filter(function (t) { return Date.now() - t < 120000; });
    if (runs.length >= 4) { log('reconcile', { skipped: 'loop-cap' }); return; }
    cartJson().then(function (cart) {
      var items = cart.items || [];
      var warranties = [];
      items.forEach(function (i) { if (isWarrantyLine(i)) warranties.push(i); });
      var used = {}, missing = [], qtyFix = {}, qtyFixCount = 0;
      items.forEach(function (it) {
        if (isWarrantyLine(it)) return;
        var price = priceFromProps(it.properties);
        if (!price) return;                              // no warranty chosen here
        var g = it.properties && it.properties._io_order_group;
        var hit = -1;
        warranties.forEach(function (w, wi) {            // prefer the explicit link
          if (used[wi] || hit > -1 || !g) return;
          var wg = w.properties && w.properties._io_parent_order_group;
          if (String(wg) === String(g)) hit = wi;
        });
        warranties.forEach(function (w, wi) {            // else an unlinked one of the same price
          if (used[wi] || hit > -1) return;
          var wg = w.properties && w.properties._io_parent_order_group;
          if (!wg && new RegExp('\\$\\s*' + price + '(\\D|$)').test(w.title || '')) hit = wi;
        });
        if (hit > -1) {
          used[hit] = true;
          // The warranty covers ONE device each, so its quantity has to track the
          // device's. Changing quantity on the cart page does not do this, which
          // leaves either an uncovered device or a warranty the customer still pays
          // for. Fix it to match, in whichever direction it drifted.
          var w = warranties[hit];
          var want = it.quantity || 1;
          if ((w.quantity || 1) !== want) { qtyFix[w.key] = want; qtyFixCount++; }
        } else {
          missing.push({ price: price, group: g || null, qty: it.quantity || 1 });
        }
      });

      // ORPHANED WARRANTY CLEANUP.
      // Everything above only ever ADDS or RESIZES warranty lines. A warranty that
      // no device claims was never looked at, so the customer kept paying for it.
      // Reproduced on the live store: change a device's quantity up and then down
      // again within about two seconds and the quantity control zeroes the line
      // before its own increase has landed. The device is removed; its warranty
      // survives, still pointing at an _io group that no longer exists. Measured
      // end state was one $489 phone with no warranty recorded against it plus a
      // live $49 warranty charge — and it did NOT heal on reload, because no code
      // path here ever removed it. It would reach checkout.
      //
      // Deliberately only runs when nothing is missing. If some device still needs
      // a warranty, an unmatched warranty line is far more likely to be a pairing
      // miss (a price that did not match the title) than a true orphan, and
      // deleting it would throw away a warranty the customer actually chose. In
      // that case leave it alone and let the block above add what it believes is
      // missing. Quantity 0 in /cart/update.js removes a line.
      var orphans = 0;
      if (!missing.length) {
        warranties.forEach(function (w, wi) {
          if (used[wi]) return;
          qtyFix[w.key] = 0;
          orphans++;
        });
        qtyFixCount += orphans;
      }

      log('reconcile', { lines: items.length, warranties: warranties.length, missing: missing.length, qtyFixes: qtyFixCount, orphans: orphans });
      if (!missing.length && !qtyFixCount) return;
      try {
        sessionStorage.setItem('__gg_recon', String(Date.now()));
        runs.push(Date.now()); sessionStorage.setItem('__gg_recon_runs', JSON.stringify(runs));
      } catch (_) {}
      var pending = missing.length + (qtyFixCount ? 1 : 0), done = 0;
      function step() { if (++done === pending) location.reload(); }
      if (qtyFixCount) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: qtyFix })
        }).then(function (r) { log('reconcileQty', { fixes: qtyFixCount, status: r && r.status }); step(); },
                function () { log('reconcileQty', { status: 'error' }); step(); });
      }
      missing.forEach(function (m) { addWarrantyLine(m, step); });
    }, function () {});
  }

  function changeJson(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function removeWarrantyLine(lineNo) {
    cartJson().then(function (cart) {
      var items = cart.items || [];
      var w = items[lineNo - 1];
      if (!w || !isWarrantyLine(w)) { location.href = '/cart/change?line=' + lineNo + '&quantity=0'; return; }
      var wg = w.properties && w.properties._io_parent_order_group;
      var wPrice = ((w.title || '').match(/\$\s*(\d+)/) || [])[1];
      var dev = null;
      items.forEach(function (it) {                       // prefer the explicit link
        if (dev || isWarrantyLine(it) || !wg) return;
        if (String(it.properties && it.properties._io_order_group) === String(wg)) dev = it;
      });
      items.forEach(function (it) {                       // else a device that chose this price
        if (dev || isWarrantyLine(it)) return;
        if (wPrice && priceFromProps(it.properties) === wPrice) dev = it;
      });
      changeJson({ line: lineNo, quantity: 0 }).then(function () {
        if (!dev) { log('removeWarranty', { device: 'none-found' }); location.reload(); return; }
        // Same state as a device added with no warranty: the field present but empty.
        // Shopify ignores an EMPTY properties object, so the empty field is required;
        // leaving out _io_order_group drops the Infinite Options link as well.
        var props = { 'Green Gadgets Warranty': '' };
        Object.keys(dev.properties || {}).forEach(function (k) {
          if (k === 'Green Gadgets Warranty' || k === '_io_order_group') return;
          props[k] = dev.properties[k];
        });
        cartJson().then(function (c2) {                  // line numbers moved after the removal
          var ln = 0;
          (c2.items || []).forEach(function (it, idx) { if (!ln && it.key === dev.key) ln = idx + 1; });
          if (!ln) { log('removeWarranty', { device: 'gone' }); location.reload(); return; }
          changeJson({ line: ln, quantity: dev.quantity || 1, properties: props }).then(
            function (r) { log('removeWarranty', { device: dev.variant_id, status: r && r.status }); location.reload(); },
            function () { log('removeWarranty', { status: 'error' }); location.reload(); }
          );
        }, function () { location.reload(); });
      }, function () { location.reload(); });
    }, function () { location.href = '/cart/change?line=' + lineNo + '&quantity=0'; });
  }

  function addWarrantyLine(m, done) {
    fetch('/products/' + m.price + '-green-gadgets-extended-warranty-24-months.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var vid = p && p.variants && p.variants[0] && p.variants[0].id;
        if (!vid) { log('reconcileAdd', { error: 'no-variant', price: m.price }); done(); return; }
        var props = { '_io_field_name': 'Green Gadgets Warranty' };
        if (m.group) props['_io_parent_order_group'] = m.group;
        addJson({ id: vid, quantity: m.qty, properties: props }).then(
          function (r) { log('reconcileAdd', { price: m.price, status: r && r.status }); done(); },
          function () { log('reconcileAdd', { price: m.price, status: 'error' }); done(); }
        );
      }, function () { log('reconcileAdd', { error: 'fetch-failed', price: m.price }); done(); });
  }

  function showOverlay() {
    try {
      if (d.getElementById('gg-atc-overlay')) return;
      var o = d.createElement('div');
      o.id = 'gg-atc-overlay';
      o.setAttribute('role', 'status');
      o.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;background:rgba(255,255,255,.85);font-family:inherit;color:#2f3a2a;';
      o.innerHTML = '<div style="width:38px;height:38px;border:3px solid #cfe0bf;border-top-color:#5f8a2e;border-radius:50%;animation:ggspin .8s linear infinite"></div><div style="font-size:15px;font-weight:600">Adding to cart…</div><style>@keyframes ggspin{to{transform:rotate(360deg)}}</style>';
      d.body.appendChild(o);
    } catch (_) {}
  }
})();
